import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { ApiUserHelperService } from './user-helper.service';

@Injectable({ providedIn: 'root' })
export class ApiUserService {
  constructor(public helper: ApiUserHelperService, private _api: ApiService) {}

  get(id: number | string) {
    return this._api.get('user/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('user/list', data);
  }

  create(data: any) {
    return this._api.post('user/create', data);
  }

  update(data: any) {
    return this._api.post('user/update', data);
  }

  remove(id: number) {
    return this._api.post('user/remove/id/' + id);
  }

  autocompleteSource(data = {}) {
    return (text?: string, id?: number) => {
      return this.list(
        text !== null
          ? { ...data, text }
          : { ids: Array.isArray(id) ? id : [id] }
      ).pipe(
        map((result) =>
          result.data.map((item: any) => {
            return {
              id: item.id,
              label:
                item.lastName + ' ' + item.firstName + ' (' + item.login + ')',
              data: item,
            };
          })
        )
      );
    };
  }
}
